module.exports = __webpack_public_path__ + "img/lantern1.b858b0ef.png";